export default "__VITE_ASSET__Gp_c5jmv__"